class TickerTape extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
  }

  connectedCallback() {
    this.slider = new Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      speed: 6000,
      autoplay: {
        delay: 0,
      },
      allowTouchMove: false,
      disableOnInteraction: false
    })
  }
}

if (!customElements.get('ticker-tape')) {
  customElements.define('ticker-tape', TickerTape);
}